import { NgModule } from '@angular/core';
import { NavItemMeComponent } from './components';

@NgModule({
    declarations: [],
    imports: [NavItemMeComponent],
    exports: [NavItemMeComponent],
})
export class NavItemMeModule {}
